import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('updateClientForm');

    return {
        SAVE: t('save')
    };
};

export default useTranslation;
